<template>
  <section class="butextual">
    <div class="butextual-info py-5">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 mb-5 mb-md-0 butextual-info__text">
            <article>
              <header class="mb-2">
                <h1 class="text-uppercase mb-1" v-html="item.text"/>
                <span
                  v-if="item.intro"
                  class="sub-title font-patrick-hand text-uppercase d-block"
                  v-html="item.intro"
                />
              </header>
              <p v-html="item.itemable.text"></p>
            </article>
          </div>
          <div class="col-12 col-md-6 butextual-info__image">
            <div
              :style="{ backgroundImage: 'url(' + item.graphic.data.graphic + ')' }"
              class="img-container w-100 h-100"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ec-business-textual',
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    surrounding: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      title: 'Dit is het ec-business-textual component.'
    }
  }
}
</script>

<style lang="scss">
.butextual {
  p {
    margin-bottom: 0;
  }
}
</style>
